import EasingFunctions from './EasingFunctions';
export default class AnimationOptions {
    constructor(init) {
        this.duration = 400;
        this.enabled = true;
        this.easingFunction = EasingFunctions.linear;
        Object.assign(this, init);
    }
}
//# sourceMappingURL=AnimationOptions.js.map